<script lang="typescript">
  // components
  import StatesToWatch from './StatesToWatch.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { PresidentRaceFeed } from '../interfaces';

  // props
  export let statesFeed: Readable<PresidentRaceFeed>;
  export let includeLinks = true;

  const watchStateFips = ['04', '13', '32', '37', '42'];

  $: activeStates = $statesFeed.states.filter((state) =>
    watchStateFips.includes(state.code)
  );
</script>

<StatesToWatch results={activeStates} {includeLinks} />
